import { AfterViewInit, Directive, ElementRef, EventEmitter, Input, OnDestroy, Output } from "@angular/core";
import { StringUtils } from "./index";

@Directive({
    selector: "[dtmUtilsEllipsifyHtml]",
    exportAs: "ellipsifyHtml",
})
export class EllipsifyHtmlDirective implements AfterViewInit, OnDestroy {
    @Input("dtmUtilsEllipsifyHtml") public maxLength!: number;
    @Output() public hasEllipsisChange = new EventEmitter<boolean>();

    public hasEllipsis = false;

    private observer: MutationObserver;

    constructor(private el: ElementRef) {
        this.observer = new MutationObserver(() => {
            this.observer.disconnect(); // NOTE: Avoid infinite loop
            this.applyTruncate();
            this.observe();
        });
    }

    public ngAfterViewInit(): void {
        this.applyTruncate();
        this.observe();
    }

    public ngOnDestroy(): void {
        this.observer.disconnect();
    }

    private observe(): void {
        this.observer.observe(this.el.nativeElement, { childList: true, characterData: true, subtree: true });
    }

    private applyTruncate(): void {
        if (this.el.nativeElement.innerHTML && this.maxLength) {
            const truncated = StringUtils.ellipsifyHtml(this.el.nativeElement.innerHTML, this.maxLength);
            if (this.el.nativeElement.innerHTML !== truncated) {
                this.el.nativeElement.innerHTML = truncated;
                this.hasEllipsis = true;
                this.hasEllipsisChange.emit(true);

                return;
            }
            this.hasEllipsis = false;
            this.hasEllipsisChange.emit(false);
        }
    }
}
